var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTokens = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.186 3.944a1.665 1.665 0 0 1 1.85 0l4.89 3.269c.462.309.739.828.739 1.384v6.806c0 .556-.277 1.075-.74 1.384l-4.888 3.27c-.56.374-1.291.374-1.851 0l-1.333-.892.739-1.106 1.333.892c.113.075.26.075.372 0l4.89-3.27a.34.34 0 0 0 .148-.278V8.597a.34.34 0 0 0-.149-.279L15.297 5.05a.34.34 0 0 0-.372 0l-1.333.892-.74-1.106z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.889 4.54 3.52 8.264v7.474l6.368 3.722 6.368-3.722V8.263zm.505-1.245a1 1 0 0 0-1.01 0L2.686 7.21a1 1 0 0 0-.495.864v7.852a1 1 0 0 0 .495.864l6.698 3.915a1 1 0 0 0 1.01 0l6.698-3.915a1 1 0 0 0 .495-.864V8.074a1 1 0 0 0-.495-.864z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
})));
export default SvgTokens;